import { z } from 'zod'

import { Pagination } from 'app/types/app/request'
import { Manager, ManagerBinding } from 'app/types/park/manager'

/** Client of a manager. */
export const Client = z.object({
    /** ID of the client. */
    id: z.number().positive(),

    /** Name of the client. */
    name: z.string().min(1),

    /** Manager of the client. */
    client: ManagerBinding,

    /** Address of the client. */
    address: z.string().min(1).nullable(),

    /** City of the client. */
    city: z.string().nullable(),

    /** Postal code of the client. */
    postal_code: z.string().min(1).nullable(),

    /** Email of the client. */
    email: z.string().email().nullable(),

    /** Phone number of the client. */
    phone_number: z.string().nullable(),

    /** Last name */
    sign_last_name: z.string().nullable(),

    /** First Name */
    sign_first_name: z.string().nullable(),

    /** Sign date */
    sign_date: z.string().nullable(),

    /** Contract duration */
    duration_contract: z.number().positive().nullable(),

    /** Contract number */
    num_contract: z.string().nullable(),
})

export type Client = z.infer<typeof Client>

export const ClientBinding = Client.pick({
    id: true,
    name: true,
    client: true,
})

export type ClientBinding = z.infer<typeof ClientBinding>

/** Full form content to create OR update a client. */
export const ClientPayload = Client.omit({
    id: true,
}).extend({
    client: Manager.shape.id,
})

export type ClientPayload = z.infer<typeof ClientPayload>

export const ClientsRequest = Pagination.extend({
    results: Client.array(),
})

export type ClientsRequest = z.infer<typeof ClientsRequest>
